<script>
import { HeaderHeight } from '@/mixins/HeaderHeight';
import { mapGetters, mapState } from 'vuex';
import { AccountConstants } from '@/constants';

export default {
  name: 'TheGlobalTopBanner',
  mixins: [HeaderHeight],
  data() {
    return {
      showBanner: true,
    };
  },
  computed: {
    ...mapGetters('auth', ['getLanguage']),
    ...mapState('configuration', ['isTopBannerEnabled']),
    hasTranslations() {
      const message = this.$t('globalTopBanner.reactUpdateMessage2025');
      return (
        message !== 'globalTopBanner.reactUpdateMessage2025' &&
        AccountConstants.TOP_BANNER_SUPPORTED_LANGUAGE.includes(
          this.getLanguage
        )
      );
    },
  },
};
</script>

<template>
  <v-alert
    class="vehicle-user-general-banner"
    :value="showBanner && hasTranslations && isTopBannerEnabled"
    color="#066FEF"
    @input="showBanner = $event"
    :style="{ top: headerHeight + 'px' }"
    data-qa="global-top-banner"
  >
    <v-layout justify-center>
      <v-flex
        xs1
        md1
        class="d-flex align-start"
        style="max-width: 40px !important"
      >
        <v-icon class="custom-info-icon" style="color: #ffffff">
          mdi-information-slab-circle
        </v-icon>
      </v-flex>
      <v-flex class="banner-text">
        {{ $t('globalTopBanner.reactUpdateMessage2025') }}
      </v-flex>
      <v-flex xs1 md1 class="d-flex align-start">
        <v-icon
          class="custom-dismiss"
          @click="showBanner = false"
          style="color: #ffffff"
        >
          close
        </v-icon>
      </v-flex>
    </v-layout>
  </v-alert>
</template>

<style scoped lang="scss">
.vehicle-user-general-banner {
  min-height: 72px;
  margin-left: 0;
  margin-right: 0;
  position: sticky;
  z-index: 1000;
}
.d-flex {
  max-width: 40px;
}
.custom-info-icon,
.custom-dismiss {
  color: white;
  font-size: 20px;
  cursor: pointer;
}
.banner-text {
  color: white;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  margin: 0 5px;
}
</style>
